import { render, staticRenderFns } from "./DealView.vue?vue&type=template&id=25ebc3aa&scoped=true&"
import script from "./DealView.vue?vue&type=script&lang=js&"
export * from "./DealView.vue?vue&type=script&lang=js&"
import style0 from "./DealView.vue?vue&type=style&index=0&id=25ebc3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ebc3aa",
  null
  
)

export default component.exports